/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Section_BasicsInputs */

const cs_automation_section_basics = /** @type {(inputs: Automation_Section_BasicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Základ`)
};

const en_automation_section_basics = /** @type {(inputs: Automation_Section_BasicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basics`)
};

/**
* | output |
* | --- |
* | "Basics" |
*
* @param {Automation_Section_BasicsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_section_basics = /** @type {((inputs?: Automation_Section_BasicsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Section_BasicsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_section_basics(inputs)
	return cs_automation_section_basics(inputs)
});